<nz-date-picker
  [class]="class"
  [formControl]="control"
  [nzFormat]="format"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
></nz-date-picker>
@if (isFormSubmitted || (control.status && control?.touched)) {
<div class="mt-2 text-danger">
  @if (control?.errors?.['required']) {
  <div class="validation-error-message">
    Please select {{ label }}
  </div>
  }
  @if (control?.errors?.['endDateBeforeStart']) {
  <div class="validation-error-message">
    End date must not be before start date
  </div>
  }
</div>
}
